"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyAnalyticsData = makeEmptyAnalyticsData;
function makeEmptyAnalyticsData() {
    return {
        numberOfHands: 0,
        totalChipsBet: 0,
        totalChipsWon: 0,
        totalChipsBlackjackBonus: 0,
        totalChipsWinStreakBonus: 0,
        maxChipsScoreDuringGame: 0,
        numberOfHandsWon: 0,
        numberOfHandsPush: 0,
        numberOfDoubles: 0,
        maxStreak: 0,
        numberOfNaturalBlackjacks: 0,
    };
}
